import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getEntries } from 'conversations-async-data/indexed-async-data/operators/getters';
import { createSelector } from '@reduxjs/toolkit';

// @ts-expect-error Untyped import
import { getCurrentThreadId } from '../../thread-history/selectors/getCurrentThreadId';
// @ts-expect-error Untyped import
import { getSortedMessagesByThreadId } from '../operators/getSortedMessagesByThreadId';
import { getUnpublishedMessages } from './getUnpublishedMessages';
export const getUnpublishedMessagesForCurrentThread = createSelector([getUnpublishedMessages, getCurrentThreadId], (unpublishedMessages, threadId) => {
  const messages = getEntries(unpublishedMessages).map(getData);
  return getSortedMessagesByThreadId(messages, threadId);
});